import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter, Route, Switch, Redirect } from "react-router-dom";

import "@fortawesome/fontawesome-free/css/all.min.css";
import "assets/styles/tailwind.css";

// layouts

import Admin from "layouts/Admin.js";
import Auth from "layouts/Auth.js";

// views without layouts

import Index from "views/Index.js";

// contact us
import Contactus from "about/aboutpage/Contactus";
import Footer2 from "components/Footers/Footer2";
import OurStory from "components/Homepage/OurStory";
import HowToApply from "components/Homepage/Admissions/HowToApply";
import FAQ from "components/Homepage/Admissions/FAQ";
import Blog from "components/Homepage/BlogPage/Blog";
import GridBlog from "components/Homepage/BlogPage/GridBlog";
import { Toaster } from "react-hot-toast";
import Founder from "components/Teams/Founder";
import Career from "components/Career";
import SchoolHead from "components/Career/SchoolHead";
import PrePrimary from "components/Career/PrePrimary";
import Manager from "components/Career/Manager";
import Operation from "components/Career/Operation";
import Foundation from "components/Homepage/Foundation";
import Entrepreneurial from "components/Entrepreneurial";
import Enquiry from "components/Enquiry";
import CareerForm from "components/Homepage/CareerForm";
import Franchise from "components/Homepage/Franchise";
import Login from "components/Homepage/Login";
import Sidebar from "components/Homepage/Dashboard/Sidebar";
import Dashboard from "components/Homepage/Dashboard/Dashboard";
import AdmissionDashboard from "components/Homepage/Dashboard/AdmissionDashboard";
import EnquiryDashboard from "components/Homepage/Dashboard/EnquiryDashboard";
import FranchiseDashboard from "components/Homepage/Dashboard/FranchiseDashboard";
import CareerDashboard from "components/Homepage/Dashboard/CareerDashboard";
import CareerView from "components/Homepage/Dashboard/CareerView";
import ThankyouAdmission from "components/Homepage/ThankyouAdmission";
import ThankyouFranchise from "components/Homepage/ThankyouFranchise";
import PrivateRoute from "components/PrivateRoute";

ReactDOM.render(
  <BrowserRouter>
    <Toaster />
    <Switch>
      {/* Aboutus page */}
      <Route path="/enquiry" exact component={Enquiry} />
      <Route path="/index" exact component={Index} />
      <Route path="/career" exact component={Career} />
      <Route path="/head-of-school" exact component={SchoolHead} />
      <Route path="/pre-primary-facilitators" exact component={PrePrimary} />
      <Route path="/admission-manager" exact component={Manager} />
      <Route path="/operation-manager" exact component={Operation} />
      <Route path="/Footer2" exact component={Footer2} />

      {/* Contact us */}
      <Route path="/contact" exact component={Contactus} />
      <Route path="/" exact component={Index} />

      {/* Teams */}
      <Route path="/leadership-teams" exact component={Founder} />
      <Route path="/foundation" exact component={Foundation} />
      <Route
        path="/entrepreneurial-preschool"
        exact
        component={Entrepreneurial}
      />

      <Route path="/ourstory" exact component={OurStory} />
      <Route path="/enroll-now" exact component={HowToApply} />
      <Route path="/become-partner" exact component={Franchise} />
      <Route path="/faqs" exact component={FAQ} />
      <Route path="/careerform" exact component={CareerForm} />
      <Route path="/grid" exact component={Blog} />
      <Route path="/gridblog" exact component={GridBlog} />
      <Route path="/login" exact component={Login} />

      {/* Protected Routes */}
      <PrivateRoute path="/sidebar" exact component={Dashboard} />
      <PrivateRoute path="/dashboard" exact component={Dashboard} />
      <PrivateRoute path="/admissiondashboard" exact component={AdmissionDashboard} />
      <PrivateRoute path="/enquirydashboard" exact component={EnquiryDashboard} />
      <PrivateRoute path="/franchisedashboard" exact component={FranchiseDashboard} />
      <PrivateRoute path="/careerdashboard" exact component={CareerDashboard} />
      <PrivateRoute path="/careerview/:id" exact component={CareerView} />

      <Route path="/admission-thank-you" exact component={ThankyouAdmission} />
      <Route path="/partner-thank-you" exact component={ThankyouFranchise} />

      {/* add redirect for first page */}
      <Redirect from="/Homepage1" to="/" />
    </Switch>
  </BrowserRouter>,
  document.getElementById("root")
);
